import { gql } from '@apollo/client';

export const CREATE_SCHOOL_PROMOTION_DATAS = gql`
  mutation createSchoolPromotionDatas($inputs: [CreateSchoolPromotionDataInput!]!) {
    promotions: createSchoolPromotionDatas(inputs: $inputs) {
      id
    }
  }
`;
